import { css } from 'styled-system/css';

export const Styles = {
	scoreboard: css({
		_mars: {
			// margin: '6px',
			// width: 'auto',
			maxWidth: 'initial',
			'& .scoreboard__cell[data-current=true] .icon--ticket-running': {
				color: 'secondary.500',
			},
			'& .scoreboard__text[data-scored=true]': {
				color: 'scoreboard.scored',
			},
			'& .scoreboard__btn .btn--icon .icon--dropdown': {
				color: 'black.3',
			},
			'& .btn--primary:not([data-disabled=true], [data-loading=true]):hover': {
				bgColor: 'black.5',
			},
			'&.scoreboard--sport50': {
				'& .scoreboard__row:first-child .scoreboard__cell-heading': {
					// color: 'white.1',
					bgColor: 'whiteOpacity.30',
				},
				// '& .scoreboard__row-inning .scoreboard__cell-heading': {
				// 	// color: 'black.2',
				// 	bgColor: 'black.5',
				// }
			},
			'& [class^=scoreboard__col] .scoreboard-ball-group .scoreboard-ball': {
				backgroundColor: 'black.3',
				'&:empty': {
					backgroundColor: 'black.5',
				},
			}
		}
	})
}